import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";
import { HbIdSchema } from "../traits";

export enum ExtractProductSchemaEnum {
	ExtractProduct = "ExtractProduct"
};

export const ExtractProductSchema = AbstractExtractSchema
	.merge(HbIdSchema)
	.merge(z.object({
		"@id": z.string(), // "/api/extract_products/1"
		"@type": z.string(), // "ExtractProduct"
		categorie: z.string(), // "Embouts avec SN"
		fournisseur: z.string(), // "Sennheiser"
		id: z.number(), // 1
		libelle: z.string(), // "EMERALD 40 S 6c"
		marque: z.string(), // "Phonak"
	}))
	.describe(ExtractProductSchemaEnum.ExtractProduct);

export type ExtractProduct = z.infer<typeof ExtractProductSchema>;
